import ChainItems from './ChainItems';
import './ChainItems.scss';

export default ChainItems;
